import { render, staticRenderFns } from "./TransferenciaForm.vue?vue&type=template&id=4d3cdebf&lang=html&"
import script from "./TransferenciaForm.vue?vue&type=script&lang=js&"
export * from "./TransferenciaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/orcamento/transferencia/TransferenciaForm.vue
// module id = 1553
// module chunks = 28